// React
import React from 'react';

// Packages
import cc from 'classcat';

// Utilities
import { useLabels } from 'utilities/hooks';

// Components
import Card from 'components/_cardContentElements';

const ResultDataCard = ({
    item,
    theme,
    children,
    methodsFieldName = null,
    showDetails,
    wrap = false,
}) => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const { object, getValueLabel } = useLabels();

    // ///////////////////
    // DATA
    // ///////////////////

    const { Choice, Name__c, Description__c } = item;

    // ///////////////////
    // RETURN
    // ///////////////////

    return (
        <div
            className={cc([
                'flex flex-col p-16 mb-24 space-y-12 border rounded-8',
                {
                    'border-teal-20': theme === 'teal',
                    'border-blue-20': theme === 'blue',
                },
            ])}>
            {/* Choice */}
            <Card.CardContentSection
                {...{
                    theme,
                    wrap,
                    title: object.label('Initiative_Result__c.Type__c'),
                }}>
                <p>
                    {getValueLabel(
                        'Initiative_Result__c.Type__c',
                        Choice?.Name
                    )}
                </p>
            </Card.CardContentSection>

            {/* Method */}
            {methodsFieldName && item[methodsFieldName] && (
                <Card.CardContentSection
                    {...{
                        theme,
                        wrap,
                        title: object.label(
                            `Initiative_Result__c.${methodsFieldName}`
                        ),
                    }}>
                    <p>
                        {getValueLabel(
                            `Initiative_Result__c.${methodsFieldName}`,
                            item[methodsFieldName]
                        )}
                    </p>
                </Card.CardContentSection>
            )}

            {/* Details */}
            {showDetails && (
                <>
                    {/* Name */}
                    <Card.CardContentSection
                        {...{
                            theme,
                            wrap,
                            title: object.label('Initiative_Result__c.Name'),
                        }}>
                        <p>{Name__c}</p>
                    </Card.CardContentSection>

                    {/* Description */}
                    {Description__c && (
                        <Card.CardContentSection
                            {...{
                                theme,
                                wrap,
                            }}>
                            <p>{Description__c}</p>
                        </Card.CardContentSection>
                    )}

                    {/* Other details */}
                    {children}
                </>
            )}
        </div>
    );
};

export default ResultDataCard;
